import React, { Component } from "react";

export default class ToggleSwitch extends Component {
    constructor() {
        super()
        this.handleToggleSwitch = this.handleToggleSwitch.bind(this)
        this.state = {
            datayes: '',
            datano: '',
        }
    }

    handleToggleSwitch(event) {
        this.props.callBack(event.target.checked)
    }

    render() {

        return (
            <div className="toggle-switch">
                <input
                    type="checkbox"
                    className="toggle-switch-checkbox"
                    name={this.props.Name}
                    id={this.props.Name}
                    onChange={this.handleToggleSwitch}
                    checked={this.props.checked}
                />
                <label className="toggle-switch-label" htmlFor={this.props.Name}>
                    <span className="toggle-switch-inner" datano={this.props.datano} datayes={this.props.datayes} />
                    <span className="toggle-switch-switch"/>
                </label>
            </div>
        );
    }
}
